import * as React from 'react';
import { lazyWithPreload } from 'react-lazy-with-preload';

const PostalPlace = lazyWithPreload(() => import('../PostalPlace'));

interface Props {
  address: string;
  postalCode: string;
}

export const Address: React.FC<Props> = ({ address, postalCode }) => (
  <>
    {address}, {postalCode}{' '}
    <React.Suspense fallback={null}>
      <PostalPlace postalCode={postalCode} />
    </React.Suspense>
  </>
);
